module.exports = __webpack_public_path__ + "img/linkedin.2c63f3b1.svg";